/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autoreply_To_InquiriesInputs */

const en_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Reply to Inquiries`)
};

const es_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta automática a consultas`)
};

const fr_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse automatique aux demandes`)
};

const de_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Antwort auf Anfragen`)
};

const ja_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせへの自動返信`)
};

const zh_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动回复咨询`)
};

const ar_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رد آلي على الاستفسارات`)
};

const id_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan Otomatis untuk Pertanyaan`)
};

const it_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta Automatica alle Richieste`)
};

const ru_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоответы на запросы`)
};

const pt_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta Automática a Dúvidas`)
};

const ko_autoreply_to_inquiries = /** @type {(inputs: Autoreply_To_InquiriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의에 대한 자동 회신`)
};

/**
* | output |
* | --- |
* | "Auto-Reply to Inquiries" |
*
* @param {Autoreply_To_InquiriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const autoreply_to_inquiries = /** @type {((inputs?: Autoreply_To_InquiriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autoreply_To_InquiriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autoreply_to_inquiries(inputs)
	if (locale === "es") return es_autoreply_to_inquiries(inputs)
	if (locale === "fr") return fr_autoreply_to_inquiries(inputs)
	if (locale === "de") return de_autoreply_to_inquiries(inputs)
	if (locale === "ja") return ja_autoreply_to_inquiries(inputs)
	if (locale === "zh") return zh_autoreply_to_inquiries(inputs)
	if (locale === "ar") return ar_autoreply_to_inquiries(inputs)
	if (locale === "id") return id_autoreply_to_inquiries(inputs)
	if (locale === "it") return it_autoreply_to_inquiries(inputs)
	if (locale === "ru") return ru_autoreply_to_inquiries(inputs)
	if (locale === "pt") return pt_autoreply_to_inquiries(inputs)
	return ko_autoreply_to_inquiries(inputs)
});